<section class="flex justify-content-center mt-4">
    <div class="card-table col-12 flex flex-column">
        <div>
            <CustomTitle [title]="'msg.misPQRSD' | translate" [showTag]="false"
                         styleClass="font-principal app-title-page-color font-medium font-23 mt-4  text-uppercase mb-0"/>
        </div>
        <p-tabView [(activeIndex)]="activeTabIndex" (activeIndexChange)="activeIndexChange($event)">
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                         <span>
                            {{'common.pendientes' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-solicitudes-historial [tramEstados]="['ACTIVO']" [tramActividadEstados]="['PENDIENTE']"></app-solicitudes-historial>
            </p-tabPanel>
            <p-tabPanel>
                <ng-template pTemplate="header">
                    <div class="flex gap-1 align-items-center">
                         <span>
                            {{'common.finalizados' |translate}}
                        </span>
                    </div>
                </ng-template>
                <app-solicitudes-historial [tramEstados]="['FINALIZADO','RECHAZADO']" [tramActividadEstados]="['FINALIZADO','REASIGNADO','REABIERTO']"></app-solicitudes-historial>
            </p-tabPanel>
        </p-tabView>
    </div>
</section>
